import { Box, useMediaQuery, useTheme } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import React, { useContext } from "react";
import { CONTACT_INFO_BY_REGISTRY } from "../../../../../config/languages";
import { AuthContext } from "../../../../../contexts/AuthContext";
import { ConfigContext } from "../../../../../contexts/ConfigContext";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import InfoBanner from "../../InfoBanner";
import MainButton from "../../MainButton";
import Text from "../../Text";
import { useWelcomeMessage } from "../hooks/useWelcomeMessage";
import { useWelcomeMessageStyle } from "../hooks/useWelcomeMessageStyle";
import { WelcomeBackMessageHeader } from "./shared/WelcomeBackMessageHeader";
import { WelcomeBackLogo } from "./shared/WelcomeBackLogo";
import { CustomRegistry } from "@nemuru-eng/js-api-client";

export default function WelcomeBackMessage({ showStartButton, onHideMessage }) {
  const { state: processContextState, dispatch } = useContext(ProcessContext);

  const isScreenXs = useMediaQuery(useTheme().breakpoints.down("xs"));

  const {
    state: { registry },
  } = useContext(ConfigContext);

  const {
    state: { agent, merchant },
  } = useContext(AuthContext);

  const {
    getProposedByValue,
    hidingLogo,
    hidingMessage,
    startApp,
    onBoardingByBorrower,
  } = useWelcomeMessage({
    onHideMessage,
    processContextState,
    dispatch,
  });
  const { itemsStyle } = useWelcomeMessageStyle({ hidingMessage });
  return (
    <>
      <WelcomeBackMessageHeader
        hidingLogo={hidingLogo}
        hidingMessage={hidingMessage}
      />
      {hidingLogo && (
        <>
          <WelcomeBackLogo />
          <Box>
            <Box mb={2}>
              <Typography
                variant={isScreenXs ? "h5" : "h4"}
                className={"mb-2 transition-all"}
                style={itemsStyle}
              >
                <strong>
                  <Text tId={"WELCOME_BACK"} />
                </strong>
              </Typography>
            </Box>
            <Typography
              variant={"subtitle1"}
              className={"transition-all"}
              style={itemsStyle}
              color="primary"
            >
              <strong>
                <Text tId={"RESUME_LOAN_PROCESS"} />
              </strong>
            </Typography>
            {(registry === CustomRegistry.CAIXABANK ||
              registry === CustomRegistry.FACILITEA ||
              registry === CustomRegistry.TESLA) && (
              <Box mt={1}>
                <Typography variant={"body2"} color={"textPrimary"}>
                  <Text
                    tId={"CUSTOMER_SUPPORT_PHONE"}
                    dynamicDataTexts={[
                      CONTACT_INFO_BY_REGISTRY[registry].phone,
                    ]}
                  />
                </Typography>
              </Box>
            )}
            <Box style={{ height: "20vh" }} />
          </Box>
          {showStartButton && (
            <Box pb={"16px"}>
              {onBoardingByBorrower && (
                <InfoBanner
                  assetType={processContextState.loan?.asset_reference[0].type}
                  proposedBy={getProposedByValue({ agent, merchant })}
                />
              )}
              <MainButton onClick={() => startApp()} />
            </Box>
          )}
        </>
      )}
    </>
  );
}
